import Swal from 'sweetalert2';
import {errorCodes} from '../interceptors/codes';

export const showSuccessToast = (message) => {
  return Swal.fire({
    toast: true,
    width: 300,
    position: 'top-end',
    icon: 'success',
    title: message || 'Success',
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
  })
}

export const showWarningToast = (message) => {
  return Swal.fire({
    toast: true,
    width: 300,
    position: 'top-end',
    icon: 'warning',
    title: message || 'Something wrong happened!',
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
  })
}

export const showErrorToast = (message) => {
  return Swal.fire({
    toast: true,
    width: 300,
    position: 'top-end',
    icon: 'error',
    title: message || 'An error occurred!',
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
  })
}

export const showSuccess = (message, title = 'Success') => {
  return Swal.fire({
    icon: 'success',
    title,
    text: message,
    footer: '<a href="">Why do I have this issue?</a>'
  });
};

export const showError = (message, title = 'Error') => {
  return Swal.fire({
    icon: 'error',
    title,
    text: message,
    footer: '<a href="">Why do I have this issue?</a>'
  });
};

export const showWarning = (message, title = 'Warning') => {
  return Swal.fire({
    icon: 'warning',
    title,
    text: message,
    footer: '<a href="">Why do I have this issue?</a>'
  });
};

export const handleError = (error, defaultMessage = 'Something went wrong!') => {
  console.error(error);

  if (error.response && (error.response.status && errorCodes[error.response.status])) {
    const errorInfo = errorCodes[error.response.status];
    return Swal.fire({
      icon: errorInfo.icon,
      title: errorInfo.title,
      text: (error.response.data && (error.response.data.narrative || error.response.data.description)) || errorInfo.message,
      footer: '<a href="">Why do I have this issue?</a>'
    });
  }

  return showError(defaultMessage);
};

export const extractErrorMessage = (error, defaultMessage = 'Something went wrong!') => {
  return error.response.data && (error.response.data.narrative || error.response.data.description) || defaultMessage;
};

export const confirmAction = async (title, text, confirmText, options = {}) => {
  return Swal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: options.confirmColor || 'green',
    cancelButtonColor: '#3085d6',
    confirmText,
    ...options
  });
};



// WEBPACK FOOTER //
// ./src/utils/notification.utils.js